'use client';

import { useEffect, useState } from 'react';

interface DeviceClassState {
  isHandheld: boolean;
  platform: 'ios' | 'android' | 'desktop';
}

const HANDHELD_MAX_WIDTH = 1024;

function evaluateDevice(): DeviceClassState {
  if (typeof window === 'undefined') {
    return { isHandheld: false, platform: 'desktop' };
  }

  const ua = window.navigator.userAgent.toLowerCase();
  const isIos = /iphone|ipad|ipod/.test(ua);
  const isAndroid = /android/.test(ua);
  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const smallViewport = window.innerWidth <= HANDHELD_MAX_WIDTH;
  const isHandheld = coarsePointer || smallViewport || isIos || isAndroid;

  return {
    isHandheld,
    platform: isIos ? 'ios' : isAndroid ? 'android' : 'desktop'
  };
}

export function useDeviceClass(): DeviceClassState {
  const [state, setState] = useState<DeviceClassState>(() => evaluateDevice());

  useEffect(() => {
    const handleResize = () => setState(evaluateDevice());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return state;
}
